<template>
  <div :class="['countdown', expireding ? 'red--text' : 'green--text']">
    <span class="days" v-if="days > 0">{{ days | twoDigits }}</span>
    <span class="hours">{{ hours | twoDigits }}:{{ minutes | twoDigits }}:{{ seconds | twoDigits }}</span>

    <div class="legend">
      <span v-if="days > 0">dd</span>
      <span>hh</span>
      <span>mm</span>
      <span>ss</span>
    </div>
  </div>
</template>

<script>
export default {
  data: () => ({
    interval: null,
    now: Math.trunc(new Date().getTime() / 1000),
    date: null,
    diff: 0,
    expireding: false
  }),

  props: {
    deadline: {
      type: Date,
      required: true
    },
    end: {
      type: String
    },
    stop: {
      type: Boolean
    }
  },

  created() {
    let endTime = this.deadline ? this.deadline : this.end;
    this.date = Math.trunc(Date.parse(endTime) / 1000);

    this.interval = setInterval(() => {
      this.now = Math.trunc(new Date().getTime() / 1000);
    }, 1000);
  },

  computed: {
    seconds() {
      return Math.trunc(this.diff) % 60;
    },

    minutes() {
      return Math.trunc(this.diff / 60) % 60;
    },

    hours() {
      return Math.trunc(this.diff / 60 / 60) % 24;
    },

    days() {
      return Math.trunc(this.diff / 60 / 60 / 24);
    }
  },

  methods: {
    changeColor() {
      let days = Math.trunc(this.diff / 60 / 60 / 24);
      let hours = Math.trunc(this.diff / 60 / 60) % 24;
      let minutes = Math.trunc(this.diff / 60) % 60;
      let seconds = Math.trunc(this.diff) % 60;

      if (days == 0 && hours == 0 && minutes <= 10) {
        this.expireding = true;
      } else if (days == 0 && hours == 0 && minutes == 0 && seconds == 0) {
        this.expireding = true;
      } else {
        this.expireding = false;
      }
    }
  },

  watch: {
    now(value) {
      this.diff = this.date - this.now;

      this.changeColor();

      if (this.diff <= 0 || this.stop) {
        this.diff = 0;
        clearInterval(this.interval);
      }
    }
  },

  filters: {
    twoDigits(value) {
      if (value.toString().length <= 1) {
        return '0' + value.toString();
      }
      return value.toString();
    }
  },

  destroyed() {
    clearInterval(this.interval);
  }
};
</script>

<style lang="scss">
.countdown {
  font-size: 0.9rem;

  span {
    &.days,
    &.hours {
      font-size: 16px;
      letter-spacing: 4px;
      font-weight: bold;
    }

    &.days {
      padding-right: 5px;
    }
  }

  .legend {
    font-size: 12px;
    margin-top: 8px;

    span {
      margin-left: 10px;
      padding: 3px 5px 3px 4px;
    }
  }
}

.theme--light {
  .legend {
    span {
      color: rgba(0, 0, 0, 0.54);
    }
  }
}

.theme--dark {
  .legend {
    span {
      color: hsla(0, 0%, 100%, 0.7);
    }
  }
}
</style>
